export default __webpack_public_path__ + "static/media/04.55e70f93.jpg";